import React, {useState, useEffect} from 'react'
import { SubPageContainer } from '../App/components/SubPageContainer'
import { PieChart } from 'react-minimal-pie-chart'
import DatePicker, { registerLocale } from 'react-datepicker'
import { frCA, enUS, es, ptBR } from 'date-fns/locale'
import 'react-datepicker/dist/react-datepicker.css'
import dayjs from 'dayjs'
import dayjsPluginUTC from 'dayjs-plugin-utc'
import dayjsTimezone from 'dayjs/plugin/timezone'
import isBetween from 'dayjs/plugin/isBetween'
import { deepCopy, randomReactKey } from '../../utilities'
import { getFetchUrl, getFetchParams } from '../../helpers'

// Tranlations
import t from '../../translations'

registerLocale('FR', frCA)
registerLocale('EN', enUS)
registerLocale('ES', es)
registerLocale('PT', ptBR)

dayjs.extend(dayjsPluginUTC)
dayjs.extend(dayjsTimezone)
dayjs.extend(isBetween)
// const localTimezone = dayjs.tz.guess()

export default function Expenses(props) {
  const {checkServerUp, noUser, lang, loginModalOpen} = props

  const [newUserMessageCategory, setNewUserMessageCategory] = useState(false)
  const [newUserMessageExpense, setNewUserMessageExpense] = useState(false)

  const [currencyRates, setCurrencyRates] = useState()
  const [selectedCurrency, setSelectedCurrency] = useState('CAD')

  const [hoveredPieIndex, setHoveredPieIndex] = useState(null)

  const [expensesData, setExpensesData] = useState([])
  const [dataFilteredByDate, setDataFilteredByDate] = useState([])

  const [pieData, setPieData] = useState([])
  const [filteredPieData, setFilteredPieData] = useState([])

  const [categoryFilter, setCategoryFilter] = useState('')
  const [explodedSegment, setExplodedSegment] = useState(-1)
  
  const [filterStart, setFilterStart] = useState()
  const [startChanged, setStartChanged] = useState(false)
  const [filterEnd, setFilterEnd] = useState()

  const [categories, setCategories] = useState([])
  const [newCategory, setNewCategory] = useState('')
  const [addOptionsOpen, setAddOptionsOpen] = useState(false)
  const [addOptionsisClosing, setAddOptionsisClosing] = useState(false)
  const [addType, setAddType] = useState('Expense')
  const [expenseFormStep, setExpenseFormStep] = useState(0)
  const [addFormData, setAddFormData] = useState({
    date: dayjs().format('YYYY-MM-DD'),
    commerce: '',
    total: '',
    amounts: [],
    currency: '',
    categories: [],
    note: '',
    uniques: [false],
  })
  const [newExpenseDate, setNewExpenseDate] = useState(dayjs().toString())

  // TODO: for the user profile page
  // Move to onload useEffect
  //
  const userPreferencesCurrencies = ['CAD', 'USD', 'UYU']
  // const userPreferedCurrency = 'CAD'
  // setSelectedCurrency(userPreferedCurrency)
  
  const formatPieData = (dataToFormat, fetchedCategories = categories) => {
    const pieColors = [
      '#2596be',
      '#9925be',
      '#be4d25',
      '#49be25',
      '#be2596',
      '#bea925',
    ]

    let formattedForPieChartData = []
    
    dataToFormat.forEach((entry) => {
      let pieDataItem = formattedForPieChartData.find((item) => item.title === entry.category)
      let value = entry.calculatedAmount ?? entry.amount

      if(pieDataItem){
        pieDataItem.value += value
      } else {
        formattedForPieChartData.push({
          title: fetchedCategories.find((cat) => cat.id === entry.categoryId).name,
          value: value
        })
      }
    })

    formattedForPieChartData = formattedForPieChartData
      .sort((a,b) => b.value - a.value)
      .map((d, i) => {
      d.color = pieColors[i % pieColors.length]
      return d
    })

    return formattedForPieChartData
  }

  // on load
  useEffect(() => {
    ;(async () => {
      // CATEGORIES
      const actionCategories = 'getCategories'
      const sessionToken = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).sessionToken : ''

      let categoriesResult
      const dataCategories = {
        a: actionCategories,
        sessionToken,
      }
      let serverResponse =await fetch(getFetchUrl('expenses'), {
        ...getFetchParams(),
        body: JSON.stringify(dataCategories),
      })
        .catch(error => {
            checkServerUp(error, noUser)
  
            return
        })
      
      if (serverResponse && serverResponse.ok) {
        categoriesResult = await serverResponse?.json()

        if(categoriesResult.data.isNewExpensesUser){
          setNewUserMessageCategory(true)
          setNewUserMessageExpense(true)
          setAddOptionsOpen(true)
          setAddType('Category')

          return
        } else if (categoriesResult?.success) {  
          setCategories(categoriesResult.data.categories)
  
        } else {
          console.log(categoriesResult?.message)
        }
      } else {
        window.location.patName = 'maintenance'
  
        return 
      }

      // EXPENSES
      const actionExpenses = 'getExpenses'

      let expensesResult
      const dataExpenses = {
        a: actionExpenses,
        sessionToken,
      }
      serverResponse =await fetch(getFetchUrl('expenses'), {
        ...getFetchParams(),
        body: JSON.stringify(dataExpenses),
      })
        .catch(error => {
            checkServerUp(error, noUser)
  
            return
        })
      
      if (serverResponse && serverResponse.ok) {
        expensesResult = await serverResponse?.json()

        if(expensesResult.data.isNewExpensesUser && !newUserMessageCategory){
          setNewUserMessageExpense(true)
          setAddOptionsOpen(true)
          
          return
        } else if (expensesResult?.success) {

          const rates = expensesResult.data.ratesByDate
          const fetchedExpenses = expensesResult.data.expenses.map((exp) => {
            exp.category = categoriesResult.data.categories.find((c) => c.id === exp.categoryId).name

            const ratesForThisDayRaw = rates.find((rate) => rate.date === exp.date).rates
            if(ratesForThisDayRaw && exp.currency !== selectedCurrency){
              const ratesForThisDay = JSON.parse(ratesForThisDayRaw)
              exp.calculatedAmount = Math.round((exp.amount / ratesForThisDay[exp.currency]) * ratesForThisDay[selectedCurrency] * 100) / 100
            }
            else{
              exp.calculatedAmount = undefined
            }

            return exp
          })
          setExpensesData(fetchedExpenses)
          setDataFilteredByDate(fetchedExpenses)

          const formattedForPieChartData = formatPieData(expensesResult.data.expenses, categoriesResult.data.categories)
          setPieData(formattedForPieChartData)
  
          setCurrencyRates(rates)

        } else {
          console.log(expensesResult?.message)
        }
      } else {
        window.location.patName = 'maintenance'
  
        return 
      }
    })()
    // eslint-disable-next-line
  }, [checkServerUp, noUser, newUserMessageCategory, newUserMessageExpense, selectedCurrency])

  // on data loaded
  useEffect(() => {
    if(expensesData.length > 0){
      setFilterStart(dayjs(expensesData?.[expensesData.length - 1]?.date).toString())
      setFilterEnd(dayjs(expensesData?.[0]?.date).toString())
    }
    
  },[expensesData, currencyRates, setFilterStart, setFilterEnd])

  // on date filter change
  useEffect(() => {
    if(!currencyRates || expensesData.length === 0){
      return
    }
    const filteredByDate = expensesData.filter((d) => {
      const date = dayjs(d.date)
      const start = dayjs(filterStart)
      const end = dayjs(filterEnd)
      return date.isBetween(start, end, 'day', '[]')
    })
      .map((d) => {
        const ratesForThisDayRaw = currencyRates.find((rate) => rate.date === d.date)?.rates
        
        if(ratesForThisDayRaw && d.currency !== selectedCurrency){
          const ratesForThisDay = JSON.parse(ratesForThisDayRaw)
          d.calculatedAmount = Math.round((d.amount / ratesForThisDay[d.currency]) * ratesForThisDay[selectedCurrency] * 100) / 100
        }
        else{
          d.calculatedAmount = undefined
        }
        
        return d
      })

    setDataFilteredByDate(filteredByDate)
    setFilteredPieData(formatPieData(filteredByDate))
    // eslint-disable-next-line
  }, [expensesData, currencyRates, filterStart, filterEnd, selectedCurrency, hoveredPieIndex])

  const expenseList = <div className='expensesListContainer'>
    <div className='displayCurrencySelector'>
      {t[props.lang]['Display amount in']}: 
      <select
        className='currencies'
        value={selectedCurrency}
        onChange={(event) => {
          setSelectedCurrency(event.target.value)
        }}
      >
        {userPreferencesCurrencies.map((currency) => {
          return <option key={randomReactKey()}>{currency}</option>
        })}
      </select>
    </div>

    <div className='expenseList header'>
      <div className='date'>
        {t[props.lang]['Date']}
      </div>
      <div className='amount'>
        {t[props.lang]['Amount']}
      </div>
      <div className='category'>
        {t[props.lang]['Category']}
      </div>
      <div className='commerce'>
        {t[props.lang]['Commerce']}
      </div>
      <div className='note'>
        {t[props.lang]['Note']}
      </div>
    </div>

    {dataFilteredByDate.map((d) => {

      if(categoryFilter !== '' && d.category !== categoryFilter){
        return <></>
      }

      return <div className='expenseList' key={randomReactKey()}>
        <div className='date'>
          {d.date}
        </div>
        <div className='amount'>
          {d.calculatedAmount?.toFixed(2) || d.amount?.toFixed(2)}
        </div>
        <div className='category'>
          {d.category}
        </div>
        <div className='commerce'>
          {d.commerce}
        </div>
        <div className='note'>
          {d.note}
        </div>
      </div>
    })}
  </div>

  const makeTooltipContent = (entry) => {
    // Remove all title from the SVG
    document.querySelectorAll('title').forEach((t) => t.remove())

    // Set tooltip text
    return <>{entry.title}: <b>{entry.value.toFixed(2)}$</b></>
  }

  const pieChart = <>
    <div className='pieChartTooltip empty'>
      {hoveredPieIndex !== null && makeTooltipContent(filteredPieData[hoveredPieIndex])}
    </div>

    <div
      onMouseMove={(event) => {
        // Set tolltip position
        const tooltipElement = document.querySelector('.pieChartTooltip')
        tooltipElement.style.top= (event.clientY -50) + 'px'
        tooltipElement.style.left= (event.clientX - 75) + 'px'

        // Hide empty tooltip
        document.querySelector('.pieChartTooltip').classList.toggle('empty', hoveredPieIndex === null)
      }}
    >
      <PieChart
        segmentsShift={(segmentIndex) => {
          if(segmentIndex === explodedSegment){
            return 5
          }

          return 0
        }}
        radius={45}
        className='pieChart'
        startAngle={-90}
        data={filteredPieData}
        labelPosition={80}
        label={(labelRenderProps) => {
          const percentage = labelRenderProps.dataEntry.percentage

          // Hide label if the pie section is too tiny
          return percentage > 5 ? `${percentage.toFixed(1)}%` : ''
        }}
        labelStyle={(segmentIndex) => {
          return {
            fontSize: '5px',
            color: '#AADD00',
          }
        }}
        onMouseOver={(_, index) => {setHoveredPieIndex(index)}}
        onMouseOut={() => {setHoveredPieIndex(null)}}
      />
    </div>
  </>

  const pieChartLegend = <div className='pieChartLegend'>
    <div className='center bold'>{t[props.lang]['Filter by category']}</div>

    <div>
      <div className='legend' style={{backgroundColor: 'white'}}/>
      <div
        onClick={() => {
          setCategoryFilter('')
          setExplodedSegment(-1)
        }}
      >
        {t[props.lang]['All']}
      </div>
    </div>
    
    {pieData.map((ld, i) => <div
      key={randomReactKey()}
      className={dataFilteredByDate.some((fd) => fd.category === ld.title) ? '' : 'disabledLegend'}
      onClick={() => {
        const enabled = dataFilteredByDate.some((fd) => fd.category === ld.title)

        if(!enabled){
          return
        }

        setCategoryFilter(ld.title)

        const renderedIndex = filteredPieData.indexOf(filteredPieData.find((fd) => fd.title === pieData.find((pd) => pd.title === ld.title).title))
        setExplodedSegment(renderedIndex)
      }}
    >
      <div className='legend' style={{backgroundColor: `${ld.color}`}}/>
      <div>{ld.title}</div>
    </div>)}
  </div>

  const filterDatesInOrder = dayjs(filterStart).isBefore(dayjs(filterEnd))
  const dateFilter = <>
    <div className='center bold'>{t[props.lang]['Filter by date']}</div>
    <div className='currentDateFilter'>
      {filterDatesInOrder ?
        `${dayjs(filterStart).format('YYYY-MM-DD')} - ${dayjs(filterEnd).format('YYYY-MM-DD')}` :
        `${dayjs(filterEnd).format('YYYY-MM-DD')} - ${dayjs(filterStart).format('YYYY-MM-DD')}`
      }
    </div>

    {!startChanged && <div
      className='datepickerRange'
      onMouseDown={(event) => {
        const targetButton = event.target.closest('button')
        if(targetButton && (targetButton.classList.contains('react-datepicker__navigation--next') || targetButton.classList.contains('react-datepicker__navigation--previous'))){
          return
        }
        setFilterStart(undefined)
      }}  // To force a date change in react-date-picker even if same date
    >
      <DatePicker
        inline
        locale={props.lang}
        selected={filterStart}
        dateFormat='yyyy-MM-dd'
        onChange={(date) => {
          setFilterStart(date)
          setStartChanged(true)
        }}
        selectsStart
        startDate={dayjs(filterDatesInOrder ? filterStart : filterEnd).toString()}
        endDate={dayjs(filterDatesInOrder ? filterEnd : filterStart).toString()}
        minDate={dayjs(expensesData?.[expensesData.length - 1]?.date).toString()}
        maxDate={dayjs(expensesData?.[0]?.date).toString()}
      />
    </div>}
    {startChanged && <div
      className='datepickerRange'
      onMouseDown={(event) => {
        const targetButton = event.target.closest('button')
        if(targetButton && (targetButton.classList.contains('react-datepicker__navigation--next') || targetButton.classList.contains('react-datepicker__navigation--previous'))){
          return
        }
        setFilterEnd(undefined)
      }}  // To force a date change in react-date-picker even if same date
    >
      <DatePicker
        inline
        locale={props.lang}
        selected={filterEnd}
        dateFormat='yyyy-MM-dd'
        onChange={(date) => {
          setFilterEnd(date)
          setStartChanged(false)
        }}
        selectsEnd
        startDate={dayjs(filterDatesInOrder ? filterStart : filterEnd).toString()}
        endDate={dayjs(filterDatesInOrder ? filterEnd : filterStart).toString()}
        minDate={dayjs(expensesData?.[expensesData.length - 1]?.date).toString()}
        maxDate={dayjs(expensesData?.[0]?.date).toString()}
      />
    </div>}
  </>

  const expenseButtons = <div className='functionButtonContainer'>
    <button
      onClick={() => {
        setAddOptionsOpen((previousState) => !previousState)
        setAddOptionsisClosing(false)
      }}
    >
      {addOptionsOpen ? t[props.lang]['Close'] : t[props.lang]['Add']}
    </button>
  </div>

  useEffect(() => {
    if(addOptionsOpen){
      document.querySelector('.addSection')?.classList.toggle('isClosing', true)

      setTimeout(()=>{
        document.querySelector('.addSection')?.classList.toggle('open', true)
      }, 0)
      setTimeout(()=>{
        document.querySelector('.addSection')?.classList.toggle('isClosing', false)
      }, 1000)
    } else{
      document.querySelector('.addSection')?.classList.toggle('open', false)
      document.querySelector('.addSection')?.classList.toggle('isClosing', true)
      
      setTimeout(()=>{
        setAddOptionsisClosing(true)
      }, 1000)
    }
  },[addOptionsOpen])

  const handleAddType = (type) => {
    setAddType(type)
  }

  const handleAddCategory = async (category) => {
    const action = 'addCategory'
    const sessionToken = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).sessionToken : ''

    const data = {
      a: action,
      sessionToken,
      formData: {
        category,
      },
    }
    const serverResponse = await fetch(getFetchUrl('expenses'), {
      ...getFetchParams(),
      body: JSON.stringify(data),
    })
      .catch(error => {
          checkServerUp(error, noUser)

          return
      })
    
    if (serverResponse && serverResponse.ok) {
      const result = await serverResponse?.json()
      if (result?.success) {
        setNewUserMessageCategory(false)
        setAddType('Expense')
        setAddFormData({
          date: dayjs().format('YYYY-MM-DD'),
          commerce: '',
          total: '',
          amounts: [],
          currency: '',
          categories: [],
          note: '',
          uniques: [false],
        })

        setCategories((previousState) => {
          const state = deepCopy(previousState)
          state.push({id: result.data.id, name: category})

          return state
        })

      } else {
        console.log(result?.message)
      }
    } else {
      window.location.patName = 'maintenance'

      return 
    }
  }

  const handleAddExpense = async () => {

    const action = 'addExpense'
    const sessionToken = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).sessionToken : ''

    const data = {
      a: action,
      sessionToken,
      formData: addFormData,
    }
    const serverResponse = await fetch(getFetchUrl('expenses'), {
      ...getFetchParams(),
      body: JSON.stringify(data),
    })
      .catch(error => {
          checkServerUp(error, noUser)

          return
      })
    
    if (serverResponse && serverResponse.ok) {
      const result = await serverResponse?.json()
      if (result?.success) {
        setExpensesData(result.data.expenses.map((exp) => {
          exp.category = categories.find((c) => c.id === exp.categoryId).name

          return exp
        }))

        setAddOptionsOpen(false)
        setAddFormData({
          date: dayjs().format('YYYY-MM-DD'),
          commerce: '',
          total: '',
          amounts: [],
          currency: '',
          categories: [],
          note: '',
          uniques: [false],
        })
        setExpenseFormStep(0)
        setNewUserMessageExpense(false)

        return result.data
      } else {
        console.log(result?.message)
      }
    } else {
      window.location.patName = 'maintenance'

      return 
    }
  }

  const currentTotal = dataFilteredByDate.reduce((acc, curr) => {
    if(categoryFilter !== '' && curr.category !== categoryFilter){
      return acc
    }

    return acc += (curr.calculatedAmount ?? curr.amount)
  }, 0).toFixed(2)


  const days = Math.abs(dayjs(filterEnd).diff(filterStart, 'day')) + 1
  const avgPerDay = (currentTotal / days).toFixed(2)

  return <SubPageContainer {...props}>
    <section className={loginModalOpen ? 'blured' : ''}>
      <h1>{t[lang].specifics_expenses['page title']}</h1>
      {expenseButtons}
      
      {(addOptionsOpen || !addOptionsisClosing) && <div className='addSection'>
        
        {expenseFormStep === 0 && <div className='radioSelectors'>
          <input
            type='radio'
            name='addType'
            disabled={newUserMessageCategory}
            checked={addType === 'Expense'}
            onChange={()=>handleAddType('Expense')}
          />
            {t[props.lang]['Expense']}
          
          <input
            type='radio'
            name='addType'
            checked={addType === 'Category'}
            onChange={()=>handleAddType('Category')}
          />
            {t[props.lang]['Category']}
        </div>}

        {addType === 'Expense' && <>
          {expenseFormStep === 0 && <>

            <div className='newExpenseCalendar'>
            <DatePicker
              inline
              locale={props.lang}
              selected={newExpenseDate}
              dateFormat='yyyy-MM-dd'
              onChange={(date) => {
                setNewExpenseDate(date)
                setAddFormData((previousState) => {
                  const value = dayjs(date).format('YYYY-MM-DD')

                  const state = deepCopy(previousState)
                  state.date = value

                  return state
                })
              }}
              maxDate={dayjs().toString()}
            />
            </div>

            <div>
              {t[props.lang]['Commerce']}: <input type='text' value={addFormData.commerce} onChange={(event) => {
                setAddFormData((previousState) => {
                  const state = deepCopy(previousState)
                  state.commerce = event.target.value

                  return state
                })
              }}/>
            </div>
            <div>
              {t[props.lang]['Total']}: <input type='number' step='0.01' min='0' value={addFormData.amounts[0]} onChange={(event) => {
                setAddFormData((previousState) => {
                  const value = +event.target.value

                  const state = deepCopy(previousState)
                  state.total = value
                  state.amounts[0] = value

                  return state
                })
              }}/>

              <select
                className='currencies'
                value={addFormData.currency}
                onChange={(event) => {
                  setAddFormData((previousState) => {
                    const value = event.target.value
  
                    const state = deepCopy(previousState)
                    state.currency = value
  
                    return state
                  })
                }}
              >
                <option value='' disabled>{t[props.lang]['Select']}</option>
                {userPreferencesCurrencies.map((currency) => <option key={randomReactKey()}>{currency}</option>)}
              </select>

            </div>
            <div>
              <button
                className={(addFormData.commerce === '' || addFormData.total === '' || addFormData.currency === '') ? 'disabled' : ''}
                disabled={addFormData.commerce === '' || addFormData.total === '' || addFormData.currency === ''}
                onClick={()=>setExpenseFormStep(1)}
              >
                {t[props.lang]['Continue']}
              </button>
            </div>
          </>}
          
          {expenseFormStep === 1 && <>
            {addFormData.amounts.map((amounts, index) => {
              const amount = amounts
              const category = addFormData.categories[index]

              return <>
                <div>
                  {t[props.lang]['Category']}: <select value={category} onChange={(event)=>{
                    setAddFormData((previousState) => {
                      const value = event.target.value

                      const state = deepCopy(previousState)
                      state.categories[index] = value

                      return state
                    })
                  }}>
                    <option value='' disabled selected>{t[props.lang]['Select']}</option>
                    {categories.map((category) => {
                      return <option value={category.id}>{category.name}</option>
                    })}
                  </select>
                </div>
              
                <div>
                  {t[props.lang]['Amount']}: <input type='number' step='0.01' min='0' value={amount} onChange={(event)=>{
                    setAddFormData((previousState) => {
                      const value = +event.target.value

                      const state = deepCopy(previousState)
                      state.amounts[index] = value

                      return state
                    })
                  }}/>

                  {t[props.lang]['Unique?']} <input type='checkbox' checked={addFormData.uniques[index]} onChange={(event)=>{
                    setAddFormData((previousState) => {
                      const value = event.target.checked

                      const state = deepCopy(previousState)
                      state.uniques[index] = value

                      return state
                    })
                  }}/>

                </div>
              </>               
            })}

            <div>
              {addFormData.total !== addFormData.amounts.reduce((acc, curr) => acc += curr, 0) && <button
                onClick={(event) => {
                  setAddFormData((previousState) => {
                    const state = deepCopy(previousState)
                    const balance = state.total - state.amounts.reduce((acc, curr) => acc += curr, 0)
                    if(balance > 0){
                      state.amounts.push(balance)
                      state.uniques.push(false)
                    }
  
                    return state
                  })
                }}
              >
                {t[props.lang]['Add']}
              </button>}

              {addFormData.total === addFormData.amounts.reduce((acc, curr) => acc += curr, 0) && <button
                className={(addFormData.categories.length !== addFormData.amounts.length) ? 'disabled' : ''}
                disabled={addFormData.categories.length !== addFormData.amounts.length}
                onClick={()=>setExpenseFormStep(2)}
              >
                {t[props.lang]['Continue']}
              </button>}
            </div>
          </>}

          {expenseFormStep === 2 && <>
            <div>
            {t[props.lang]['Note']}: <textarea value={addFormData.note} onChange={(event) => {
                setAddFormData((previousState) => {
                  const state = deepCopy(previousState)
                  state.note = event.target.value

                  return state
                })
              }}/>

              <div>
                <button
                  onClick={handleAddExpense}
                >
                  {t[props.lang]['Finish']}
                </button>
              </div>
            </div>
          </>}
        </>}
        
        {addType === 'Category' && <div>
          {t[props.lang]['Category']}: <input type='text' value={newCategory} onChange={(event)=>{
            setNewCategory(event.target.value)
          }}/>

          <div>
            <button
              onClick={()=>handleAddCategory(newCategory)}
            >
              {t[props.lang]['Submit']}
            </button>
          </div>

          {newUserMessageCategory && <div className='newUserMessageExpenses'>
            {t[props.lang]['newUserMessage']} 
          </div>}
        </div>}

      </div>}

      {!(newUserMessageCategory || newUserMessageExpense) && <>
        <div className='pieChartContainerOuter'>
          <div className='pieChartContainerInnerLeft'>
            <b>{t[props.lang]['Total']}: {currentTotal} {selectedCurrency}</b><br/>
            <small>Avg. per day: {avgPerDay} {selectedCurrency}</small>
            {categoryFilter !== '' && <div>
              <i>{categoryFilter}</i>
            </div>}
            {pieChart}
          </div>
          <div className='pieChartContainerInnerRight'>
            {dateFilter}
            {pieChartLegend}
          </div>
        </div>
        
        {expenseList}
      </>}
      
    </section>
  </SubPageContainer>
}